import { useEffect } from 'react';

/**
 * Issue #374: Scroll the window back to the top when a page mounts so that
 * users navigating from another screen (e.g. Profile -> Terms / Privacy /
 * Community Guideline) start reading the document from the first line
 * instead of inheriting the previous page's scroll position.
 *
 * Uses the default (instant) scroll behavior so no animation is introduced,
 * which keeps the change neutral with respect to `prefers-reduced-motion`.
 */
const useScrollToTop = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
};

export default useScrollToTop;
